import { Link } from 'react-router-dom';
import { articles, categories, siteInfo } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 4);
  const latestArticles = articles.slice(0, 9);
  const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 4);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '911黑料网',
    url: 'https://www.911heilian.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.911heilian.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '911黑料网',
    url: 'https://www.911heilian.com',
    description: siteInfo.description,
    foundingDate: String(siteInfo.foundedYear),
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.email,
      contactType: '爆料线索',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>

      <main>
        <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20urban%20alley%20at%20night%20with%20red%20neon%20lights%2C%20wet%20pavement%20reflections%2C%20breaking%20news%20concept%2C%20dramatic%20cinematic%20cityscape%2C%20deep%20shadows%20and%20warm%20accent%20lights%2C%20noir%20atmosphere%2C%20moody%20photography%20with%20rich%20contrast&width=1600&height=700&seq=hero-main&orientation=landscape"
            alt="911黑料网 - 独家爆料内容聚合平台"
            title="911黑料网 - 独家爆料内容聚合平台"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
            <h1 className="font-heading font-black text-3xl md:text-5xl text-white mb-4 max-w-3xl leading-tight">
              掌握别人不知道的<strong className="text-primary-400">内幕信息</strong>
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
              专注独家爆料、真实内幕揭秘的内容聚合平台。汇聚娱乐圈、社会热点、明星黑料等第一手资讯。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <Link
                to="/category/dujia"
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                查看独家爆料
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-20">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex flex-col items-center gap-2 p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${cat.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{cat.name}</span>
                <span className="text-xs text-foreground-500">{cat.count}篇</span>
              </Link>
            ))}
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
                <a href="/">🔥 热门爆料</a>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">全网最受关注的独家内幕</p>
            </div>
            <Link
              to="/category/dujia"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {hotArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        <section className="bg-background-100 py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
                  <a href="/">📰 最新爆料</a>
                </h2>
                <p className="text-sm text-foreground-500 mt-1">第一时间掌握独家资讯</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-900">
                <a href="/">🔍 独家深度</a>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">只有在这里才能看到的深度调查</p>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            {exclusiveArticles.slice(0, 2).map((article) => (
              <ArticleCard key={article.id} article={article} variant="large" />
            ))}
          </div>
        </section>

        <section className="bg-background-900 py-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
              你有料，我们有平台
            </h2>
            <p className="text-background-400 max-w-lg mx-auto mb-8 leading-relaxed">
              如果你掌握一手内幕信息，欢迎通过匿名通道向我们爆料。我们承诺对爆料人信息绝对保密，重大线索给予高额奖励。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                立即爆料
              </a>
              <Link
                to="/about"
                className="px-6 py-3 bg-background-800 hover:bg-background-700 text-background-200 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                爆料指南
              </Link>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-12">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
            <div>
              <div className="text-3xl font-heading font-bold text-primary-500">{siteInfo.stats.totalArticles}</div>
              <div className="text-sm text-foreground-500 mt-1">总爆料数</div>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-accent-500">{siteInfo.stats.exclusiveArticles}</div>
              <div className="text-sm text-foreground-500 mt-1">独家爆料</div>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-primary-500">{formatStatNumber(siteInfo.stats.dailyVisitors)}</div>
              <div className="text-sm text-foreground-500 mt-1">日均访问</div>
            </div>
            <div>
              <div className="text-3xl font-heading font-bold text-accent-500">{siteInfo.stats.verifiedReporters}</div>
              <div className="text-sm text-foreground-500 mt-1">认证记者</div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

function formatStatNumber(num: number): string {
  if (num >= 10000) return `${(num / 10000).toFixed(0)}万`;
  return num.toString();
}